// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2V3pv","info":"UpdateTermsInfo_info__6HbLM"};